import { render, staticRenderFns } from "./KeepingSectors.vue?vue&type=template&id=2ac35e8a&scoped=true"
import script from "./KeepingSectors.vue?vue&type=script&lang=js"
export * from "./KeepingSectors.vue?vue&type=script&lang=js"
import style0 from "./KeepingSectors.vue?vue&type=style&index=0&id=2ac35e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac35e8a",
  null
  
)

export default component.exports